import AxiosFactory from '@/entities/security/AxiosFactory'
import {
  CHECK_USER_VERIFICATION,
  DISABLE_TWO_FA_URL,
  GET_TWO_FA_URL,
  USER_VERIFICATION_RESENT,
} from '@/modules/securitySettings/endpoints'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import {
  disableTwoFAPayloadI,
  enableTwoFAPayloadI,
  getTwoFAPayloadI,
} from '@/modules/securitySettings/types/api/SecuritySettingsApi'
export default class SecuritySettingsApi {
  async initTwoFA(data: getTwoFAPayloadI) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(GET_TWO_FA_URL, data)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async enableTwoFA(data: enableTwoFAPayloadI) {
    try {
      const response = await AxiosFactory.createAxiosInstance().put(GET_TWO_FA_URL, data)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async disableTwoFA(data: disableTwoFAPayloadI) {
    try {
      const response = await AxiosFactory.createAxiosInstance().patch(DISABLE_TWO_FA_URL, data)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async resentVerificationEmail() {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(USER_VERIFICATION_RESENT)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async checkVerificationEmail(token: string) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${CHECK_USER_VERIFICATION}?token=${token}`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
}
